import React from "react";
import { Col, PageHeader, Row, Button, Space } from "antd";
import { useHistory, useParams } from "react-router-dom";
import {
  Profil,
  StokIslemVeVaryantListe,
  IslemButton,
} from "../components/varyantliStokDetay";
import strings from "../utils/Localization";

function VaryantliStokDetay() {
  const history = useHistory();
  const { stokId } = useParams();
  const { varyantliStokDetay: localization } = strings;
  return (
    <>
      <PageHeader
        onBack={() => history.goBack()}
        ghost={false}
        title={localization.pageHeader.baslik}
        extra={
          <Space>
            <Button
              size="large"
              type="link"
              onClick={() => history.push(`/StokVaryantGrupEkle/${stokId}`)}
            >
              {localization.pageHeader.varyantGrupEkle}
            </Button>
            <IslemButton />
          </Space>
        }
      />
      <br />
      <Row gutter={24}>
        <Col xxl={6} xl={7} lg={24} md={24} xs={24}>
          <Profil />
          <br />
        </Col>
        <Col xxl={18} xl={17} lg={24} md={24} xs={24}>
          <StokIslemVeVaryantListe />
        </Col>
      </Row>
      <br />
    </>
  );
}

export default VaryantliStokDetay;
